(() => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.getElementById('MobileNav');
  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menuButton.textContent = open ? 'MENU' : 'CLOSE';
      mobileNav.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-message-studio]').forEach((button) => {
    button.addEventListener('click', (event) => {
      if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
        event.preventDefault();
        window.ShopifyChat.open();
      }
    });
  });

  const mainImage = document.querySelector('[data-product-main-image]');
  const mainButton = document.querySelector('[data-product-main-button]');
  const lightbox = document.querySelector('[data-lightbox]');
  const lightboxImage = document.querySelector('[data-lightbox-image]');

  document.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      document.querySelectorAll('[data-product-thumb]').forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
      mainImage.src = thumb.dataset.src;
      mainImage.alt = thumb.dataset.alt || '';
      mainImage.dataset.fit = thumb.dataset.fit || 'cover';
      mainImage.dataset.zoom = thumb.dataset.zoom || 'true';
      if (mainButton) mainButton.setAttribute('aria-disabled', String(mainImage.dataset.zoom === 'false'));
    });
  });

  if (mainButton && mainImage && lightbox && lightboxImage) {
    mainButton.addEventListener('click', () => {
      if (mainImage.dataset.zoom === 'false') return;
      lightboxImage.src = mainImage.src;
      lightboxImage.alt = mainImage.alt;
      lightbox.showModal();
    });
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox || event.target.matches('[data-lightbox-close]')) lightbox.close();
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const price = document.querySelector('[data-product-price]');
      const button = form && form.querySelector('[data-add-to-cart]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      }
    });
  });
})();
